export enum AppZIndex {
  Min = '1',
  TimerSlideButtons = '2',
  TrainingBannerContent = '3',
  PasswordForm = '4',
  TopMenu = '10',
  PathRequestsEducationVerificationScreen = '20',
  VideoPlayButton = '98',
  StickyBar = '110',
  SideMenu = '120',
  UserMenu = '200',
  NavMenu = '300',
  SearchBar = '350',
  ComparisonTable = '400',
  LoadingScreen = '9999'
}
